<div *ngIf="isLoading" class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>
<div class="container" *ngIf="orderItem && !isLoading; else noOrderStatus">
    <div class="top-secton">
        <div class="top-left-section">
            <!-- Visible only back arrow icon when the page is not open from email link -->
            <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
            <div class="heading-section">
                <p>
                    {{ "orderDetailInfo.orderStatus" | translate }}:
                    <span class="heading">{{ orderItem.itemStatus }}</span>
                </p>
                <span class="divider"></span>
                <p class="order-status-date">{{ orderItem.updatedAt | date: "dd MMM YYYY" }}</p>
            </div>
        </div>
    </div>

    <div class="middle-section-container">
        <div class="middle-section">
            <img
                class="product-image"
                *ngIf="orderItem.product?.images; else placeholder"
                [src]="orderItem.product?.images?.imagesUrl?.[0]"
            />
            <ng-template #placeholder>
                <div class="image-placeholder"></div>
            </ng-template>

            <div class="product-detail">
                <span class="product-name">{{ orderItem.product?.name }}</span>
                <p>
                    Quantity: <span>{{ orderItem.quantity }}</span>
                </p>
                <p>
                    Price:
                    <strong
                        >Rs.{{
                            orderItem.product?.discountedPrice
                                ? orderItem.product?.discountedPrice
                                : orderItem.product?.price
                        }}
                    </strong>
                </p>
            </div>
        </div>
    </div>

    <!-- Track order Section -->
    <div class="order-process-section">
        <div class="shipped-text-section">
            <div class="shipped-left-section">
                <div class="text-wrapper" *ngIf="orderItem.itemStatus === OrderStatus.Dispatched">
                    <span class="shipped-text">{{ "orderStatus.shipped" | translate }}</span>
                    <span class="package-text">{{ "orderStatus.facility" | translate }}</span>
                </div>
                <p class="sub-heading" *ngIf="orderItem.itemStatus === OrderStatus.Delivered">
                    {{ "orderStatus.packageHanded" | translate }}
                </p>
            </div>
        </div>
        <!-- Separate timeline track -->
        <div class="timeline-section">
            <!-- Ordered to Delivered & cancel timeline section -->
            <app-order-timeline
                *ngIf="
                    showTimeline &&
                    (orderItem.itemStatus === OrderStatus.Ordered ||
                        orderItem.itemStatus === OrderStatus.Packed ||
                        orderItem.itemStatus === OrderStatus.Dispatched ||
                        orderItem.itemStatus === OrderStatus.Delivered ||
                        orderItem.itemStatus === OrderStatus.Cancelled)
                "
                [statusHistory]="filteredOrderStatusHistory!"
            ></app-order-timeline>

            <!-- Return Timeline Section -->
            <app-order-timeline
                *ngIf="
                    orderItem.itemStatus === OrderStatus.ReturnInitiated ||
                    orderItem.itemStatus === OrderStatus.Returned ||
                    orderItem.itemStatus === OrderStatus.PickupScheduled
                "
                [statusHistory]="filteredReturnOrderStatusHistory!"
            ></app-order-timeline>

            <!-- Exchanged Timeline Section -->
            <app-order-timeline
                *ngIf="
                    orderItem.itemStatus === OrderStatus.ExchangeInitiated ||
                    orderItem.itemStatus === OrderStatus.ExchangePacked ||
                    orderItem.itemStatus === OrderStatus.Exchanged ||
                    orderItem.itemStatus === OrderStatus.ExchangeDispatched
                "
                [statusHistory]="filteredExchangeOrderStatusHistory!"
            ></app-order-timeline>
            <!-- </div>   -->
            <!-- END    -->

            <!-- Connecting timeline track
         <div class="timeline-section">
           <app-order-timeline
                [statusHistory]="filteredOrderStatusHistory!"
            ></app-order-timeline>
        </div> -->
        </div>
    </div>
</div>

<!-- No order ID & OrderItem -->
<ng-template #noOrderStatus class="no-order-container">
    <app-no-order-item></app-no-order-item>
</ng-template>
